<div class="sip-condition-groups-summary">
  <div *ngIf="!sipConditionGroup" class="arm-summary">0 Items selected</div>
  <div *ngIf="sipConditionGroup" class="arm-summary">
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span [title]="sipConditionGroup.name" class="arm-summary-value" fxFlex>{{sipConditionGroup.name}}</span>
    </div>
    <ac-line-separator title="Conditions"></ac-line-separator>

    <div class="conditions" *ngFor="let condition of sipConditionGroup.conditions; let i = index">
      <span>{{i + 1}}. </span>
      <span class="subject">{{condition.subject}} </span>
      <span class="operator">{{condition.displayData.operator}} </span>
      <span class="values" [ngSwitch]="condition.operator">
        <span *ngSwitchCase="'regex'">{{condition.regex}}</span>
        <span *ngSwitchCase="'belong'">{{condition.displayData.prefixGroups}}</span>
        <span *ngSwitchDefault>{{condition.values.join(', ')}}</span>
      </span>
      <span class="logical-operator"> {{condition.logicalOperator}}</span>
    </div>
  </div>
</div>
